import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';
import { useCapabilities } from '../../hooks/useCapabilities';

export const NotFound = () => {

  const navigate = useNavigate();
  const { getFirstAccessibleRoute } = useCapabilities();

  const handleGoHome = () => {
    navigate(getFirstAccessibleRoute());
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" component="h1" color="primary" sx={{ mb: 2 }}>
          404
        </Typography>
        <Typography variant="h4" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          The page you're looking for doesn't exist or is in construction.
        </Typography>
        <Button variant="contained" size="large" onClick={handleGoHome}>
          Go Home
        </Button>
      </Box>
    </Container>
  );
};
